// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/adozione/piani?societaId=1',
    requestBody: null,
    response: '{"success":true,"data":[{"id":1,"societaId":1,"titolo":"Adozione BOP 2026","dataInizio":"2026-09-10","dataFine":"2026-12-10","stato":"ATTIVO","giorniPreavviso":3,"societa":{"id":1,"nome":"Pianinvest"},"createdBy":{"id":1,"nome":"Paolo","email":"..."},"_count":{"obiettivi":4}}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/adozione/piani/1',
    requestBody: null,
    response: '{"success":true,"data":{"id":1,"titolo":"Adozione BOP 2026","descrizione":null,"dataInizio":"2026-09-10","dataFine":"2026-12-10","stato":"ATTIVO","giorniPreavviso":3,"societa":{"id":1,"nome":"Pianinvest"},"createdBy":{"id":1,"nome":"Paolo","email":"..."},"obiettivi":[{"id":1,"titolo":"Ciclo attivo operativo","descrizione":null,"scadenza":"2026-10-31","ordine":0,"attivo":true,"attivita":[{"id":1,"titolo":"Inserire i primi 10 ordini","assegnatoAId":3,"scadenza":"2026-10-15","stato":"DA_FARE","notaAssegnatario":null,"completatoAt":null,"inRitardo":false,"assegnatoA":{"id":3,"nome":"Marco","email":"..."}}],"avanzamento":{"totale":1,"completate":0,"nonApplicabili":0,"inCorso":0,"percentuale":0,"stato":"DA_INIZIARE","inRitardo":false}}],"feedback":[],"riepilogo":{"totale":1,"completate":0,"nonApplicabili":0,"inCorso":0,"percentuale":0,"stato":"DA_INIZIARE","inRitardo":false,"obiettivi":1,"obiettiviInRitardo":0,"feedbackAperti":0}}}'
  },
  {
    method: 'GET',
    endpoint: '/api/adozione/piani/1/utenti-assegnabili',
    requestBody: null,
    response: '{"success":true,"data":[{"id":3,"nome":"Marco","email":"marco@..."}]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/adozione/attivita/1/stato',
    requestBody: '{"stato":"COMPLETATA","notaAssegnatario":"fatto"}',
    response: '{"success":true}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/adozione/attivita/1',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/adozione/piani',
    requestBody: '{"societaId":1,"titolo":"Adozione BOP 2026","dataInizio":"2026-09-10","dataFine":"2026-12-10","descrizione":null,"giorniPreavviso":3}',
    response: '{"success":true,"data":{"id":1}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/adozione/piani/1/stato',
    requestBody: '{"stato":"ATTIVO"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/adozione/piani/1/obiettivi',
    requestBody: '{"titolo":"Ciclo attivo operativo","scadenza":"2026-10-31","descrizione":null}',
    response: '{"success":true,"data":{"id":1}}'
  },
  {
    method: 'POST',
    endpoint: '/api/adozione/obiettivi/1/attivita',
    requestBody: '{"titolo":"Inserire i primi 10 ordini","assegnatoAId":3,"scadenza":"2026-10-15","descrizione":null}',
    response: '{"success":true,"data":{"id":1,"avvisi":[]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/adozione/feedback',
    requestBody: '{"pianoId":1,"tipo":"DIFFICOLTA","testo":"..."}',
    response: '{"success":true,"data":{"id":1}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/adozione/feedback/1',
    requestBody: '{"rispostaTesto":"...","stato":"CHIUSO"}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
